import React from 'react';
import { useStore } from '../../../../Stores/store';
import './Picture.css';

interface Props {
    url: string,
    alt: string,
    id: string,
    isActive: boolean
}

export default function PictureTile({url, alt, id, isActive}: Props){
    const { managementStore } = useStore();
    const { setSelectedPictureId } = managementStore;

    return(
        <div
            key={id}
            id={`${id}`}
            onClick={() => {window.scrollTo(0, 0); setSelectedPictureId(id)}}
            className={`pictureTile${isActive ? ' ring-2 ring-green-500 ring-offset-1' : ''}`}
        >
            <img src={url} alt={alt} />
            {isActive && (
                <span className="absolute bottom-1 left-1/2 -translate-x-1/2 bg-green-500 text-white text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap">
                    Active
                </span>
            )}
        </div>
    );
}